export const ON_LOAD = 'app/on_load';
export const onLoad = () => ({
  type: ON_LOAD
});

export const ON_LOAD_SUCCESS = 'app/on_load_success';
export const onLoadSuccess = () => ({
  type: ON_LOAD_SUCCESS,
});

export const TOGGLE_LOADING = 'app/toggle_loading';
export const toggleLoading = (bool) => ({
  type: TOGGLE_LOADING,
  payload: bool
});

export const SET_ERROR = 'app/error';
export const setError = (title, message, obj) => ({
  type: SET_ERROR,
  payload: {
    title: title,
    message: message,
    obj: obj
  }
});

export const SET_CONFIG = 'app/set_config';
export const setConfig = (data) => ({
  type: SET_CONFIG,
  payload: data
});
